export const getters = {
  getModalViewAddress: state => state.modalViewAddress,
  getAddresses: state => state.addresses,
  getAddress: state => state.address
};

export default {};
